import type { FC } from "react";
import EDD from "../types/EDD";
import PatientDisposition from "../types/PatientDisposition";
import SuggestionDetailPopoverShell from "./suggestion-detail-popover-shell";
import SuggestionExplainabilityPopoverContent from "./suggestion-explainability-popover-content";

export interface SuggestionExplainabilityPopoverProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;
  suggestion: PatientDisposition | EDD;
  suggestionType: string;
}

/**
 * Explainability detail: shared {@link SuggestionDetailPopoverShell} +
 * {@link SuggestionExplainabilityPopoverContent}.
 */
const SuggestionExplainabilityPopover: FC<
  SuggestionExplainabilityPopoverProps
> = ({ open, anchorEl, onClose, suggestion, suggestionType }) => (
  <SuggestionDetailPopoverShell
    open={open}
    anchorEl={anchorEl}
    onClose={onClose}
  >
    <SuggestionExplainabilityPopoverContent
      suggestion={suggestion}
      suggestionType={suggestionType}
      onClose={onClose}
    />
  </SuggestionDetailPopoverShell>
);

export default SuggestionExplainabilityPopover;
